@let _displayedForks = searchService.displayedForks() || [];

<div class="ada-container ada-col-1 ada-colspan-1 ada-flex-column ada-full-height">
	@if (aida.isSearchOpen()) {
		<ada-search-navigation
			[index]="activeIndex()"
			[maxHeight]="ui.Spacing.SPACING_XLARGE"
			[numberOfMatches]="_displayedForks.length"
			[value]="searchService.currentQuery()"
			(close)="toggleSearch()"
			(indexChange)="indexChange($event)"
			(valueChange)="search($event)"
		/>
	}
	<div
		ada-background-color="background-2"
		class="ada-container ada-col-1 ada-colspan-1 ada-flex-column ada-overflowY-auto ada-full-height"
	>
		@for (_fork of _displayedForks; track _fork.nodeId) {
			@let _isActive = _fork.nodeId === forkService.activeForkId();

			<div
				class="ada-container ada-colspan-1 ada-border-bottom ada-flex-justify-between"
				style.padding="{{ ui.Spacing.SPACING_MEDIUM }}"
				[adaContextMenuTrigger]="Menu"
				[adaMenuTriggerData]="_fork"
				[class.ada-background-color-primary-alpha-25]="_isActive"
				[class.ada-border-inner-left-primary-3px]="_isActive"
			>
				<div
					class="ada-container ada-colspan-1 ada-flex-column"
					[style.gap]="ui.Spacing.SPACING_SMALL"
				>
					<div
						ada-color="foreground"
						ada-font-weight="bold"
						class="ada-display-flex ada-flex-align-center"
						[style.gap]="ui.Spacing.SPACING_SMALL"
					>
						<span>{{ _fork.forkName }}</span>

						@if (_isActive) {
							<ada-search-tag
								text="Current"
								[isCloseButtonVisible]="false"
							/>
						}
					</div>
					<span
						ada-color="foreground"
						ada-opacity="50"
						ada-type="small"
					>
						{{ _fork.llmResponseReceivedTimestamp | adaLocalizedDate: 'short' }} &middot; {{ _fork | adaLlmForkArtifactCount }} Artifacts
					</span>
				</div>
				<div class="ada-container">
					@if (!_isActive) {
						<button
							aria-label="Switch to Fork"
							class="ada-btn ada-btn-solid ada-btn-small ada-btn-no-margin"
							title="Switch to Fork"
							[style.margin-right]="ui.Spacing.SPACING_MEDIUM"
							(click)="onForkClick(_fork)"
						>
							Switch
						</button>
					}

					<button
						aria-label="Open Fork Menu"
						class="ada-btn ada-btn-flat ada-btn-icon ada-btn-small ada-btn-no-margin ada-btn-no-padding"
						data-test-id="ada-fork-fork-menu-trigger"
						[adaMenuTrigger]="Menu"
						[adaMenuTriggerData]="_fork"
					>
						<ada-icon
							#HeaderMenuIcon
							ada-type="base"
							color="primary"
							icon="faEllipsisH"
						/>
					</button>
				</div>
			</div>
		}

		@if (_displayedForks.length < 3) {
			<div
				ada-color="foreground"
				class="ada-llm-forks-explanation ada-text-align-center"
			>
				Create multiple paths in your conversation to explore ideas without losing context in other forks
			</div>
		}
	</div>
</div>
<ada-menu
	#Menu
	[controller]="menuController"
/>
